'use strict';

(
  function () {

    var levels = {
      low: 'low',
      medium: 'medium',
      high: 'high'
    };

    var constants = {
      fullCost: 'Full Cost',
      careTypes: {
        nonResidential: 'nonResidential',
        carephone: 'carephone',
        respite: 'respite',
        week1Residential: 'week1Residential',
        week5Residential: 'week5Residential',
        week13Residential: 'week13Residential'
      },
      userTypes: {
        user: 'user',
        partner: 'partner'
      },
      severeDisabilityPremium: 76.4,
      residential: {
        totalSavingsThreshold: 23250
      },
      // Define the periodicity of incomes, expenses, etc. that have a fixed periodicity which is not weekly
      fixedPaymentPeriods: {
        councilTax: 'Annually'
      },
      pensionCreditAllowances: {
        maxDisregardSingle: 6.5,
        maxDisregardCouple: 9.75,

        coupleIncomeLowerBound: 277.12,
        coupleIncomeUpperBound: 306.85,
        singleIncomeLowerBound: 174.49,
        singleIncomeUpperBound: 201.05
      },
      expenseTypes: [
        'compulsoryPayments',
        'councilTax',
        'mortgage',
        'rent',
        'waterRates',
        'homeContentsInsurance',
        'groundRent'
      ],
      upliftableIncomeTypes: [
        'attendanceAllowance',
        'mobilityAllowance'
      ],
      incomeTypes: [
        'childBenefit',
        'earningsFromPaidEmployment',
        'incapacityBenefit',
        'otherBenefit',
        'pensionGuaranteeCredit',
        'pensionSavingsCredit',
        'privatePension',
        'retirementPension',
        'warPension',
        'warDisablementPension',
        'warSpecialPayment',
        'carersAllowance'
      ],
      levels: levels,
      carersPremium: 49.05,
      childPremium: 94.9,
      maxWeeklyContribution: 5000,
      capitalDisregard: {
        user: 14250,
        partner: 14250,
        // in the spreadsheet, this is embedded in the "Capital Tariff" cell formula
        threshold: 36
      },

      attendanceAllowance: {
        low: {
          amount: 26.9
        },
        medium: {
          amount: 68.1
        },
        high: {
          amount: 101.75
        }
      },
      warSpecialPaymentDisregard: 111.74,
      partnersEarningsDisregarded: 0.45,
      mobilityAllowance: {
        low: {
          amount: 26.9
        },
        high: {
          amount: 71
        }
      },
      personalLivingAllowance: {
        residentialRate: 28.25,

        // NB: at next uplift
        // when PLA tables are updated, note:
        // partnerNonResidential figures are supplied as couples MIG rate
        // partnerRespite are supplied as single MIG rate

        singleServiceUser: [
          {
            age: levels.low,
            disabled: levels.low,
            value: 82.15
          },
          {
            age: levels.low,
            disabled: levels.medium,
            value: 127.9
          },
          {
            age: levels.low,
            disabled: levels.high,
            value: 150.25
          },
          {
            age: levels.medium,
            disabled: levels.low,
            value: 103.65
          },
          {
            age: levels.medium,
            disabled: levels.medium,
            value: 149.4
          },
          {
            age: levels.medium,
            disabled: levels.high,
            value: 171.75
          },
          {
            age: levels.high,
            disabled: levels.low,
            value: 214.35
          },
          {
            age: levels.high,
            disabled: levels.medium,
            value: 214.35
          },
          {
            age: levels.high,
            disabled: levels.high,
            value: 214.35
          }
        ],

        coupleServiceUser: [
          {
            age: levels.low,
            disabled: levels.low,
            value: 81.4
          },
          {
            age: levels.low,
            disabled: levels.medium,
            value: 114
          },
          {
            age: levels.low,
            disabled: levels.high,
            value: 130.05
          },
          {
            age: levels.medium,
            disabled: levels.low,
            value: 81.4
          },
          {
            age: levels.medium,
            disabled: levels.medium,
            value: 114
          },
          {
            age: levels.medium,
            disabled: levels.high,
            value: 130.05
          },
          {
            age: levels.high,
            disabled: levels.low,
            value: 163.65
          },
          {
            age: levels.high,
            disabled: levels.medium,
            value: 163.65
          },
          {
            age: levels.high,
            disabled: levels.high,
            value: 163.65
          }
        ],
        // also known to Kirklees as the couple / partner MIG rate
        partnerNonResidential: [
          {
            age: levels.low,
            disabled: levels.low,
            value: 133.3
          },
          {
            age: levels.low,
            disabled: levels.medium,
            value: 190.1
          },
          {
            age: levels.low,
            disabled: levels.high,
            value: 218
          },
          {
            age: levels.medium,
            disabled: levels.low,
            value: 133.3
          },
          {
            age: levels.medium,
            disabled: levels.medium,
            value: 190.1
          },
          {
            age: levels.medium,
            disabled: levels.high,
            value: 218
          },
          {
            age: levels.high,
            disabled: levels.low,
            value: 306.85
          },
          {
            age: levels.high,
            disabled: levels.medium,
            value: 306.85
          },
          {
            age: levels.high,
            disabled: levels.high,
            value: 306.85
          }
        ],
        // also known to Kirklees as the single / partner MIG rate
        partnerRespite: [
          {
            age: levels.low,
            disabled: levels.low,
            value: 67.2
          },
          {
            age: levels.low,
            disabled: levels.medium,
            value: 107.05
          },
          {
            age: levels.low,
            disabled: levels.high,
            value: 126.6
          },
          {
            age: levels.medium,
            disabled: levels.low,
            value: 84.8
          },
          {
            age: levels.medium,
            disabled: levels.medium,
            value: 124.65
          },
          {
            age: levels.medium,
            disabled: levels.high,
            value: 144.2
          },
          {
            age: levels.high,
            disabled: levels.low,
            value: 201.05
          },
          {
            age: levels.high,
            disabled: levels.medium,
            value: 201.05
          },
          {
            age: levels.high,
            disabled: levels.high,
            value: 201.05
          }
        ]
      }
    };

    angular.module('kerp-forms.forms').constant('kirkleesCareAssessmentConstants', constants);
  }()
);
